import { render, staticRenderFns } from "./changemess.vue?vue&type=template&id=3a50b65e&scoped=true"
import script from "./changemess.vue?vue&type=script&lang=js"
export * from "./changemess.vue?vue&type=script&lang=js"
import style0 from "./changemess.vue?vue&type=style&index=0&id=3a50b65e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50b65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a50b65e')) {
      api.createRecord('3a50b65e', component.options)
    } else {
      api.reload('3a50b65e', component.options)
    }
    module.hot.accept("./changemess.vue?vue&type=template&id=3a50b65e&scoped=true", function () {
      api.rerender('3a50b65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parts/changemess.vue"
export default component.exports